import { useContext } from 'react';
import { ThemeContext } from '../providers/ThemeProvider';

export type ThemeMode = 'light' | 'dark' | 'system';

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within an AppThemeProvider');
  }
  return context;
}
